// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html{scroll-behavior:auto}body{background-color:#f5f5f5}@media screen and (min-width:1640px){html .site-container{background-repeat:no-repeat;background-size:165%}html .site-container .entry{background-color:#fff;padding:2rem}html .site-container .geoloc_container{background-color:#fff}}", ""]);
// Exports
module.exports = exports;
